import { FacebookMessenger } from "assets/images";
import { Button } from "components";
import React from "react";

function Facebook() {
  return (
    <div
      className={`h-[309px] bg-[#F1F1F1] shadow-md flex flex-col justify-center px-6`}
    >
      <div className="flex flex-col gap-7">
        <div className="flex items-center space-x-2">
          <FacebookMessenger className="w-8 h-8" />
          <p className="pt-1">Facebook Messenger</p>
        </div>
        <div className="flex flex-col gap-6">
          <p className="font-bold text-[#0D121D]">
            Connect your Facebook Messenger to your Fonu account{" "}
          </p>
          <p className="text-[#474A4E] text-[14px]">
            We will need permission to manage your Facebook Messenger Account in
            order to automate your replies. <br /> You can create Facebook bot
            on connected accounts.
          </p>
          <div className="w-[400px]">
            <Button>Connect to Facebook Messenger</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Facebook;
